import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    RelationCheckboxes,
    Password,
    CheckBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffUsersEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState('');
    const [formUsername, setFormUsername] = useState('');
    const [formPhone, setFormPhone] = useState('');
    const [formEmail, setFormEmail] = useState('');
    const [formTaroffShopId, setFormTaroffShopId] = useState(null);
    const [formTaroffShopIdOptions, setFormTaroffShopIdOptions] = useState([]);
    const [formUserGroups, setFormUserGroups] = useState([]);
    const [formUserGroupsOptions, setFormUserGroupsOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-users-edit/select-data/taroff-shop-id').then(
            (response) => {
                setFormTaroffShopIdOptions(response.data);
            }
        );
        postData('/api/panel/page/taroff-users-new/select-data/user-groups').then(
            (response) => {
                setFormUserGroupsOptions(response.data);
            }
        );
    }, []);
    const [formPassword, setFormPassword] = useState('***');
    const [formIsActive, setFormIsActive] = useState(false);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-users-edit/save-data', {
            id: allProps['id'],
            title: formTitle,
            username: formUsername,
            phone: formPhone,
            email: formEmail,
            taroff_shop_id: formTaroffShopId,
            password: formPassword,
            is_active: formIsActive,
            groups: formUserGroups,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-users-edit/form-data', {
            id: allProps['id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormUsername(response.data.username);
            setFormPhone(response.data.phone);
            setFormEmail(response.data.email);
            setFormTaroffShopId(response.data.taroff_shop_id);
            setFormIsActive(response.data.is_active);
            setFormUserGroups(response.data.groups);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'نام'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'نام کاربری'}
                            value={formUsername}
                            onChange={setFormUsername}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'شماره همراه'} value={formPhone} onChange={setFormPhone} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'ایمیل'} value={formEmail} onChange={setFormEmail} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'فروشگاه'}
                            options={formTaroffShopIdOptions}
                            value={formTaroffShopId}
                            onChange={setFormTaroffShopId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <Password
                            label={'کلمه عبور'}
                            value={formPassword}
                            onChange={setFormPassword}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox label={'فعال'} value={formIsActive} onChange={setFormIsActive} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <RelationCheckboxes label={'گروه ها'} options={formUserGroupsOptions} value={formUserGroups} onChange={setFormUserGroups} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
